/**
 * Экран «мини-апп выключен» — партнёр снял тумблер в кабинете.
 *
 * Отдельный от `BotDisabledScreen` намеренно: тот говорит «продажи приостановлены
 * или аккаунт заблокирован», а здесь бот жив и продолжает продавать, просто через
 * чат. Показать вместо этого экран про блокировку — значит отправить человека
 * писать в поддержку по поводу, которого нет.
 */

import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { StateScreen } from '@/components/StateScreen';
import { Btn } from '@/components/ui/tiles';
import { getWebApp } from '@/lib/telegram';

export function WebappDisabledScreen() {
  const { t } = useTranslation();

  const handleClose = () => {
    const tg = getWebApp();
    tg?.close();
  };

  return (
    <StateScreen icon={<MessageSquare />} tone="neutral" title={t('Webapp off title')} description={t('Webapp off description')}>
      <Btn className="w-full" onClick={handleClose}>
        {t('Webapp off close')}
      </Btn>
    </StateScreen>
  );
}
